<template>
    <div class="wrap-withdrawal">
        <h4>Withdrawal</h4>
        <section class="content-withdrawal">
            <div class="title">
                <h5>Daftar Withdrawal</h5>
                <button type="button" class="btn btn-primer" v-b-modal.modal-1>Tambah</button>
            </div>
            <div style="overflow-x:auto">
                <table class="table">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Nama</th>
                            <th>Platform</th>
                            <th>Bank</th>
                            <th>Jumlah</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(withdrawal, i) in withdrawals" :key="i" v-show="withdrawals.length > 0">
                            <td>{{ i + 1 }}</td>
                            <td>{{ withdrawal.customer_id.fullname }}</td>
                            <td>
                                {{ withdrawal.platform.name }}
                            </td>
                            <td>
                                <div v-for="(bank, i) in withdrawal.customer_id.bank_account" :key="i">
                                    {{ bank.name }}
                                </div>
                            </td>
                            <td>{{ currencyFormat(withdrawal.amount) }}</td>
                            <td>
                                <span class="status" :class="{ success: withdrawal.status == 'accepted', warning: withdrawal.status == 'rejected' }">{{
                                    withdrawal.status
                                }}</span>
                            </td>
                        </tr>
                        <tr v-show="withdrawals.length == 0" class="text-center">
                            <td colspan="6">No Data Available in Table</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <b-modal id="modal-1" title="Request Withdrawal">
                <form>
                    <div class="form-group">
                        <label for="" class="label-form">Tanggal withdrawal</label>
                        <input type="date" class="form-input" v-model="today" :max="today" readonly />
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Bank</label>
                        <input type="text" class="form-input" v-model="dataCustomer.name" readonly />
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Nama Nasabah</label>
                        <input type="text" class="form-input" v-model="dataCustomer.account_name" readonly />
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">No Rekening</label>
                        <input type="text" class="form-input" v-model="dataCustomer.account_no" readonly />
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Platform</label>
                        <select name="" id="" v-model="$v.form.platform_code.$model">
                            <option v-for="(platform, i) in platforms" :value="platform.code" :key="i">{{ platform.name }}</option>
                        </select>
                        <div v-if="$v.form.platform_code.$error">
                            <div class="form-error" v-if="!$v.form.platform_code.required">
                                Platform tidak boleh kosong
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Jumlah</label>
                        <input type="text" class="form-input" v-model="$v.form.amount.$model" @input="handleInput" />
                        <div v-if="$v.form.amount.$error">
                            <div class="form-error" v-if="!$v.form.amount.required">
                                Platform tidak boleh kosong
                            </div>
                        </div>
                    </div>
                </form>
                <template #modal-footer>
                    <button type="submit" class="btn btn-scondary" @click="$bvModal.hide('modal-1')">Cancel</button>
                    <button type="submit" class="btn btn-primer" @click="submitwithdrawal">
                        <span v-if="!isLoading"> Submit</span>
                        <b-spinner variant="light" small v-else style="width: 20px; height: 20px"></b-spinner>
                    </button>
                </template>
            </b-modal>
            <b-modal ref="modalDetail" title="Detail withdrawal">
                <div class="d-block modal-detail" v-if="withdrawal">
                    <div>
                        <label class="label">Nama</label> <span> : </span> <span>{{ withdrawal.account_name }}</span>
                    </div>
                    <div>
                        <label class="label">Platform</label> <span> : </span> <span>{{ withdrawal.platform.name }}</span>
                    </div>
                    <div>
                        <label class="label">Bank</label> <span> : </span> <span>{{ withdrawal.bank_name }}</span>
                    </div>
                    <div>
                        <label class="label">No Rekening</label> <span> : </span> <span>{{ withdrawal.account_no }}</span>
                    </div>
                    <div>
                        <label class="label">Jumlah</label> <span> : </span> <span>{{ withdrawal.amount }}</span>
                    </div>
                    <div>
                        <label class="label">Tanggal withdrawal</label> <span> : </span>
                        <span>{{ withdrawal.withdrawal_date ? withdrawal.withdrawal_date : "" }}</span>
                    </div>
                    <div>
                        <label class="d-block label">Bukti Transfer</label>
                        <img :src="url + withdrawal.image" alt="Bukti Transfer" class="image" />
                    </div>
                </div>
            </b-modal>
        </section>
    </div>
</template>

<script>
import Axios from "axios";
import { required } from "vuelidate/lib/validators";
export default {
    data() {
        return {
            withdrawals: [],
            withdrawal: "",
            platforms: [],
            dataCustomer: "",
            isLoading: false,
            url: "https://api-kyc-abi-dev.abicommodity.co.id/v2/get/file",
            today: "",
            form: {
                customer_id: "",
                platform_code: "",
                amount: "",
            },
        };
    },
    validations: {
        form: {
            platform_code: {
                required,
            },
            amount: {
                required,
            },
        },
    },
    watch: {
        // "form.amount"(val, oldVal) {
        //   console.log(oldVal);
        //   let newVal = val;
        //   console.log(newVal);
        //   val = this.formatIDR(oldVal);
        //   this.form.amount = val;
        // },
    },
    computed: {
        amountDisplay: {
            get() {
                return this.form.amount;
            },
            set(value) {
                this.form.amount = (value + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            },
        },
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        this.$store.dispatch("getCustomer").then((resCustomer) => {
            this.dataCustomer = resCustomer.bank_account[0];
            let id = resCustomer._id;
            this.form.customer_id = id;
            this.platforms = resCustomer.platform;
            Axios.get("/v2/kyc/withdrawal?", {
                params: {
                    customer_id: id,
                    limit: 3,
                },
            }).then((res) => {
                this.withdrawals = res.data.data.withdrawal;
            });
        });
    },
    methods: {
        currencyFormat(value) {
            return (value + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        formatNumber(value) {
            return value.replace(/[^\d]/g, "");
        },
        handleInput() {
            this.form.amount = (this.form.amount + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        formatIDR(value) {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        onFileImage() {
            let image = this.$refs.image.files[0];
            if (image.type == "image/jpg" || image.type == "image/jpeg" || image.type == "image/png") {
                let formData = new FormData();
                formData.append("file", image);
                Axios.post("/v2/kyc/upload", formData).then((res) => {
                    this.form.image = res.data.data;
                });
            }
        },
        submitwithdrawal() {
            this.$v.form.$touch();
            if (this.$v.form.$error) {
                return;
            }

            const data = {
                customer_id: this.form.customer_id,
                platform_code: this.form.platform_code,
                amount: this.formatNumber(this.form.amount),
            };

            this.isLoading = true;
            Axios.post("/v2/kyc/withdrawal/", data)
                .then((res) => {
                    if (res.data.data.status_code == "00") {
                        this.isLoading = false;
                        this.$toast.success("Permintaan Withdrawal berhasil", {
                            position: "top-center",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: false,
                            pauseOnHover: false,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: true,
                            rtl: false,
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    let status = error.response.data.data.status_code;
                    if (status == "1004") {
                        this.$toast.error("Permintaan withdrawal dalam proses", {
                            position: "top-center",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: false,
                            pauseOnHover: false,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: true,
                            rtl: false,
                        });
                    }
                });
        },
        showModalDetail(value) {
            this.withdrawal = value;
            this.$refs["modalDetail"].show();
        },
        hideModalDetail(idModal) {
            this.$refs[idModal].hide();
        },
    },
};
</script>

<style scoped>
.content-withdrawal {
    font-size: 14px;
    background-color: #fff;
    border-radius: 1rem;
    box-shadow: 0 0 2rem 0 rgb(136 152 170 / 13%);
    margin-top: 3rem;
}

.title {
    padding: 1rem;
    display: flex;
    justify-content: space-between;
}

.label-form {
    display: block;
}

.btn-primer,
.btn-scondary {
    font-size: 13px;
    width: unset;
    height: unset;
    padding: 0.5rem 1rem;
}

.form-error {
    font-size: 13px;
    color: #dc3545;
}

.form-input,
select {
    width: 100%;
    height: 2.5rem;
}

.image {
    width: 18rem;
}

.label {
    font-weight: bold;
    width: 9rem;
}
.status {
    font-weight: bold;
}

.status.success {
    color: #28a745;
}

.status.warning {
    color: #dc3545;
}
</style>
